import crud from '@/crud/index/index'
import resources from '../../resources'

import components from './components'
import computed from './computed'
import data from './data'
import methods from './methods'

export default {
  components,
  computed,
  data,
  methods,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/index/resources/index.js